import type { HttpAdapter } from "../core/adapters/axios.adapter"
import type { NewsDO } from "./news.data"

export class NewsService {
  private k: number = 100
  private min_score: number = 0

  constructor(private newsAdapter:HttpAdapter) { }

  async load(query?: string | null, tokens?: string | null, title?: string | null): Promise<NewsDO[]> {
    const params = new URLSearchParams()

    params.set('top_k', this.k.toString())
    params.set('min_score', this.min_score.toString())

    if (query) params.set('query', query)
    if (tokens) params.set('tokens', tokens)
    if (title) params.set('title', title)

    const response = await this.newsAdapter.get<NewsDO[]>(`?${params}`);
    return response.data; 
  }
}
